import type { Component } from "solid-js";
import { useTranslation } from "../../../state/i18n";
import { IconButton } from "../../../components/button/Button";
import DeleteFormModal from "../folder/DeleteFormModal";
import type FormId from "../../../state/FormId";
import type FolderId from "../../../state/FolderId";
import { useModalManager } from "../../../components/modal/ModalManager";
import { useCustomerState } from "../../../state/customer";

type DeleteFormButtonProps = {
  folderId: FolderId;
  formId: FormId;
  formName: string;
};

const DeleteFormButton: Component<DeleteFormButtonProps> = (props) => {
  const { t } = useTranslation();
  const { open } = useModalManager();
  const customer = useCustomerState();

  return (
    <IconButton
      icon="trash"
      aria-label={t(($) => $.DELETE_ARIA)}
      variant="secondary"
      onClick={() => {
        open({
          content: () => (
            <DeleteFormModal
              customerId={customer.customerId}
              folderId={props.folderId}
              formId={props.formId}
              formName={props.formName}
            />
          ),
        });
      }}
    />
  );
};

export default DeleteFormButton;
